<template>
    <div class="content">
        <div class="seach">
            <input
                type="text"
                placeholder="可输入合同标号、城市搜索"
                v-model="sSeach"
                @input="getSeach"
            />
        </div>
        <div class="list_warp">
            <div class="list_type_title">喜报列表</div>
            <div class="pull">
                <pull-to
                    :top-load-method="downRefresh"
                    :bottom-load-method="upRefresh"
                    :is-bottom-bounce="true"
                    bottom-block-height:0
                    top-block-height:0
                >
                    <div class="list_contetn">
                        <div
                            class="list"
                            v-for="(item, index) in arrList"
                            :key="index"
                        >
                            <div class="list_img">
                                <img preview="1" :src="item.img" alt="" style="" />
                            </div>
                            <div class="list_text" v-if="item.code">
                                项目号:{{ item.code }}
                            </div>
                            <div class="list_btn_item">
                                <div>{{ item.city }}</div>
                                <div>{{ item.created_at | dateTime }}</div>
                            </div>
                        </div>
                    </div>
                </pull-to>
            </div>
        </div>
    </div>
</template>
<script>
import PullTo from "vue-pull-to";
import oDetail from "@/js/detail.js";
import { Toast } from "mint-ui";
export default {
    components: {
        PullTo,
    },
    data() {
        return {
            sSeach: "", //输入关键词
            arrList: [],
            nPage: 0,
            bLoading: false,
        };
    },
    created() {
        let _that = this;
        $init(() => {
            _that.getPosterList();
        });
    },
    filters: {
        dateTime(val) {
            let timeDate = val.replace(/\-/g, "/");
            let y = String(new Date(timeDate).getFullYear());
            y = y.substring(y.length - 2, y.length);
            let m = new Date(timeDate).getMonth() + 1;
            let r = new Date(timeDate).getDay();
            return y + "-" + m + "-" + r;
        },
    },
    methods: {
        //搜索
        getSeach() {
            let _that = this;
            _that.debounce(() => {
                _that.nPage = 0;
                _that.arrList = [];
                _that.bLoading = false;
                _that.getPosterList();
            }, 300);
        },
        //节流函数防抖
        debounce(fn, delay) {
            let context = this; // this指向发生变化，需要提出来
            let args = arguments;
            return (function () {
                if (context.timer) {
                    clearTimeout(context.timer);
                }
                context.timer = setTimeout(() => {
                    fn.apply(context, args);
                }, delay);
            })(); // 注意:我加了()
        },
        //喜报列表
        getPosterList() {
            let _that = this;
            let data = {
                page: _that.nPage,
                limit: 10,
                search: _that.sSeach,
            };
            _that.$store.commit("loadSwitch", true);
            oDetail.getPosterList(data).then((res) => {
                let arrList = res.result.list;
                if (arrList.length < 10) {
                    _that.bLoading = true;
                }
                _that.arrList = _that.arrList.concat(arrList);
                _that.$previewRefresh();//执行查看图片方法
                _that.$store.commit("loadSwitch", false);
            });
        },
        //下拉
        downRefresh(loaded) {
            this.nPage = 0;
            this.arrList = [];
            this.bLoading = false;
            loaded("done");
            this.getPosterList();
        },
        //上拉
        upRefresh(loaded) {
            loaded("done");
            if (this.bLoading) {
                Toast({
                    message: "没有更多了~",
                    duration: 800,
                });
                return false;
            }
            this.nPage += 1;
            this.getPosterList();
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 100vh;
    padding: 30px;
    box-sizing: border-box;
    .seach {
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        box-shadow: 0px 0px 30px 0px rgba(168, 207, 251, 0.4);
        border-radius: 10px;
        border: solid 1px #bec9f9;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &::before {
            content: "";
            display: inline-block;
            background: url("~@/assets/images/seach_icon.png") no-repeat
                center/100% 100%;
            width: 24px;
            height: 27px;
            margin-right: 12px;
        }
        input {
            width: 93%;
            height: 70px;
        }
    }
    .list_warp {
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 0px 30px 0px rgba(168, 207, 251, 0.4);
        border-radius: 10px;
        border: solid 1px #bec9f9;
        height: calc(100vh - 180px);
        margin-top: 20px;
        padding: 20px;
        box-sizing: border-box;
        .list_type_title {
            font-size: 30px;
            color: #333333;
            font-weight: 700;
            display: flex;
            align-items: center;
            &::before {
                content: "";
                display: inline-block;
                width: 6px;
                height: 30px;
                background-color: #2c7aec;
                margin-right: 20px;
            }
        }
        .pull {
            width: 100%;
            height: calc(100% - 20px);
            overflow: hidden;
        }
        .list_contetn {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            justify-content: space-between;
            margin-top: 20px;
            .list {
                width: 315px;
                height: auto;
                background-color: #ffffff;
                border-radius: 8px;
                border: solid 1px #bec9f9;
                padding-bottom: 23px;
                box-sizing: border-box;
                overflow: hidden;
                margin-bottom: 20px;
                .list_img {
                    width: 100%;
                    height: 400px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    img {
                        width: 100%;
                        border: 0;
                    }
                }
                .list_text {
                    font-size: 24px;
                    font-weight: 700;
                    text-align: center;
                    margin-top: 18px;
                }
                .list_btn_item {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    width: 100%;
                    margin-top: 18px;
                    div {
                        padding: 14px 20px;
                        box-sizing: border-box;
                        font-size: 24px;
                        color: #333;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 6px;
                        background-color: #ffffff;
                        border-radius: 50px;
                        border: solid 1px #cacaca;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>